import { Pipe, PipeTransform } from '@angular/core';
import {
  CheckRequestStatusEnum,
  CheckRequestStatusInfo,
} from '@qaroni-app/check/types/check-request-status.enum';

@Pipe({
  name: 'checkRequestsStatusName',
  standalone: false,
})
export class CheckRequestsStatusNamePipe implements PipeTransform {
  transform(value: CheckRequestStatusEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(CheckRequestStatusInfo, value)
    ) {
      return CheckRequestStatusInfo[value].name;
    }

    return value;
  }
}
